import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Employment } from 'src/@core/interfaces/employment/employment.model';
import { Search } from 'src/@core/interfaces/search';
import { JobApplication } from 'src/@core/interfaces/job/job-application.model';
import { entityTypes, roles } from 'src/app/shared/helpers/roles-permissions';
import { environment } from 'src/environments/environment';
import { Attendance } from 'src/@core/interfaces/job/attendance.model';
import { DeleteEvent } from 'src/@core/interfaces/delete-event';
import { ConfirmDeleteDialogComponent } from 'src/app/shared/components/confirm-delete-dialog/confirm-delete-dialog.component';
import { MatDialog } from '@angular/material';
import { EnterpriseAdminService } from 'src/app/modules/enterprise-admin/enterprise-admin.service';
import { NotificationService } from 'src/@core/services/notification.service';
import { AddEditTaskComponent } from '../add-edit-task/add-edit-task.component';

@Component({
  selector: 'hour4u-admin-view-detail-tasks',
  templateUrl: './view-detail-tasks.component.html',
  styleUrls: ['./view-detail-tasks.component.scss']
})
export class ViewDetailTasksComponent implements OnInit {

  dataChange: BehaviorSubject<any>;
  @Input('jobApplication') jobApplication: any;
  @Input('jobApplications') jobApplications: any;
  @Input('jobseeker') jobseeker: any;
  @Input('selectedView') selectedView: boolean;
  @Input('forAll') forAll: any;
  @Input('employment') employment: any;

  @Output() refreshPage = new EventEmitter();
  showProgress = true;
  roles = roles;
  entityTypes = entityTypes;
  baseImageUrl = environment.image_url;
  isLoading: boolean = false;
  diameter = 30;
  color: string;
  mode = 'indeterminate';
  disableBtn: boolean = false;
  taskImages: any[] = [];

  constructor(
    private dialog: MatDialog,
    public enterpriseAdminService: EnterpriseAdminService,
    private notify: NotificationService
  ) { }

  ngOnInit() {
    console.log("jobApplication======", this.jobApplication, this.jobApplications, this.jobseeker, this.selectedView, this.forAll, this.employment)
    if (this.jobApplication && this.jobApplication.dateTime && this.jobApplication.dateTime.length) {
      this.jobApplication.datee = new Date(this.jobApplication.dateTime[0] + "-" + this.jobApplication.dateTime[1] + "-" + this.jobApplication.dateTime[2])
      this.jobApplication.time = [this.jobApplication.dateTime[3], this.jobApplication.dateTime[4]];

    }
    if (this.jobApplication) {
      if (this.jobApplication.workProofs && this.jobApplication.workProofs.length) {
        this.taskImages = [];
        this.jobApplication.workProofs.forEach(element => {
          if (element.fieldType == 'file') {
            if (element.fieldValue) {
              this.taskImages.push({
                image: element.fieldValue,
                thumbImage: element.fieldValue,
                title: element.fieldLabel + ' Image'
              })
            }
          }
        });

        let isImageField = this.jobApplication.workProofs.filter((ip: any) => ip.fieldType === 'file')
        if (isImageField && !isImageField.length) {
          this.taskImages.push({
            image: this.jobApplication.imagePath ? this.baseImageUrl + this.jobApplication.imagePath : './assets/img/gallery.svg',
            thumbImage: this.jobApplication.imagePath ? this.baseImageUrl + this.jobApplication.imagePath : './assets/img/gallery.svg',
            title: this.jobApplication.description + ' Image'
          })
        }
      } else {
        this.taskImages.push({
          image: this.baseImageUrl + this.jobApplication.imagePath,
          thumbImage: this.baseImageUrl + this.jobApplication.imagePath,
          title: 'Image'
        })
      }
    }
  }

  isEven(index) {
    if (index % 2 === 0) {
      return false;
    } else {
      return true;
    }
  }

  editTask(jobApplication) {
    console.log(jobApplication)
    jobApplication.isEdit = true;
  }

  jobDateChange(event) {
    console.log(event)
  }

  // approve Reject Task
  approveRejectTask(data, status) {
    this.disableBtn = true;
    console.log(data, status)
    let param = {
      id: data.id,
      employmentHistoryId: data.employmentHistoryId,
      imageProfPath: data.imagePath,
      updatedStatus: status,
    }
    this.enterpriseAdminService.updateTaskStatus(param).subscribe(async (res) => {
      this.notify.showMessage("Work Picture status updated Successfully!", 2000);
      this.refreshPage.emit();
      this.disableBtn = false;
    }, (err => {
      this.disableBtn = false;
      this.notify.showMessage("Work Picture status update failed!", 2000);
    }))
  }

  addEditTasks(selectedData?: any) {
    selectedData.label = 'Edit';
    selectedData.employmentId = this.employment.workOrder.id;
    selectedData.champsList = this.jobApplications;
    selectedData.forAll = this.forAll;
    let obj = {
      selectedTask: selectedData,
      selectedJobSeeker: this.jobseeker
    }
    const dialogRef = this.dialog.open(AddEditTaskComponent, {
      width: '500px',
      data: obj,
      panelClass: 'add-edit-venue-dialog',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.refreshPage.emit();
      }
    });
  }

  // delete Task
  deleteTask(row) {
    console.log(row)
    const data = new DeleteEvent();
    data.setId(row.jobSeekerId);
    data.setName(row.tempJobSeekerName);
    data.setType('Proof Of Work');
    const dialogRef = this.dialog.open(ConfirmDeleteDialogComponent, {
      disableClose: true,
      data
    });

    dialogRef.afterClosed().subscribe(code => {
      if (code) {
        this.deleteImage(row);
      }
    });
  }

  // delete attendance Image
  async deleteImage(data: any) {
    this.isLoading = true;
    let param = {
      id: data.id,
      previousImagePath: data.imagePath,
      workOrderId: this.employment.workOrder.id,
      jobSeekerId: data.jobSeekerId,
      proofEnum: data.proofEnum,
      description: data.description
    }
    this.enterpriseAdminService.DeleteAttendanceImgProof(param).subscribe(async (res) => {
      this.isLoading = false;
      this.notify.showMessage("Work Picture deleted Successfully!", 2000);
      this.refreshPage.emit();
    }, (err => {
      this.isLoading = false;
      this.notify.showMessage("Work Picture deleted failed!", 2000);
    }))
  }

}
